import React, { PropsWithChildren } from 'react';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const Layout = ({ children }: PropsWithChildren) => {
  return <RootFlex>{children}</RootFlex>;
};

const RootFlex = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  overflow: 'hidden',
});

export default Layout;
